'use client';

import { useTranslations } from 'next-intl';

interface MobileStickyTotalProps {
  totalRon: number;
}

export function MobileStickyTotal({ totalRon }: MobileStickyTotalProps) {
  const t = useTranslations('giftVouchers');
  return (
    <div
      className="fixed inset-x-0 z-50 lg:hidden"
      style={{ bottom: 'var(--selection-bar-height, 0px)' }}
    >
      <div className="bg-[#2c1810] px-5 py-3 flex items-center justify-between shadow-2xl">
        <span className="text-sm font-medium text-white/80">{t('total')}</span>
        <span className="text-xl font-bold text-white">{totalRon.toLocaleString()} RON</span>
      </div>
    </div>
  );
}
